export const jobApplicationExtension = ["pdf"];

export const jobApplicationMaxSize = 5000000; // 5MB
